
import Vue, { PropType } from 'vue';

// Data
import languageList from '~/data/languages.json';
import proficiencyList from '~/data/proficiencies.json';

// Components
import Select, { SelectOption } from '~/components/builders/Base/Select.vue';
import InfoBox from '~/components/profile/components/InfoBox.vue';

// Services & types
import { CandidateJobBuilder } from '~/utils/candidate';

export default Vue.extend({
    name: 'LanguagesForm',
    components: {
        Select,
        InfoBox,
    },
    props: {
        builder: {
            type: Object as PropType<CandidateJobBuilder>,
            required: true,
        },
        loading: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            languages: this.builder.getLanguages(),
        };
    },
    mounted() {
        this.$watch('languages', this.builder.watchLanguages());
    },
    computed: {
        optionsLanguages(): SelectOption<string>[] {
            return languageList.map(lang => ({
                value: lang.value,
                label: this.$t(`profile.languages.languages.${lang.value}`) as string,
            }));
        },
        optionsProficencies(): SelectOption<string>[] {
            return proficiencyList.map(prof => ({
                value: prof.value,
                label: this.$t(`profile.languages.proficiencies.${prof.value}`) as string,
            }));
        },
        isAddDisabled(): boolean {
            return Boolean(
                this.languages.length > 0 && !this.languages[this.languages.length - 1].languageId
            );
        },
    },
    methods: {
        handleAddLanguage() {
            this.languages.push({
                id: CandidateJobBuilder.generateId(),
                languageId: '',
                proficiencyId: undefined,
            });
        },
        handleChangeLanguageId(idx: number, languageId: string) {
            const language = this.languages[idx];
            const languages = [...this.languages];
            languages[idx] = { ...language, languageId };
            this.languages = languages;
        },
        handleChangeProficiencyId(idx: number, proficiencyId: string) {
            const language = this.languages[idx];
            const languages = [...this.languages];
            languages[idx] = { ...language, proficiencyId };
            this.languages = languages;
        },
        handleRemoveLanguage(idx: number) {
            const languages = [...this.languages];
            languages.splice(idx, 1);
            this.languages = languages;
        },
    },
});
